export class TestParameterRequest {
    codes: string[];
}
